export enum ContainerSize {
    FiftyThree = 0,
    FourtyEight = 1,
    Fourty = 2,
    LTL = 3,
    HotShot = 4
}

export const ContainerSizeMetadata = {
    '0': {
        display: '53 Foot',
        value: 0
    },
    '1': {
        display: '48 Foot',
        value: 1
    },
    '2': {
        display: '40 Foot',
        value: 2
    },
    '3': {
        display: 'LTL',
        value: 3
    },
    '4': {
        display: 'Hot Shot',
        value: 4
    }
};
